module.exports = __webpack_public_path__ + "slide-07.png?26db4b2f68d8c159c8cce7560f3462a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide-07.png
// module id = 399
// module chunks = 0